import React from 'react';

export default function VideoEmbed({ videoId = "pVWdJyF-sZ4" }) {
  return (
    <div
      style={{
        marginTop: '1rem',
        marginBottom: '3rem',
        paddingTop: '3rem',
        paddingBottom: '3rem',
        backgroundColor: '#232F3E',
        color: 'white',
      }}
    >
      <h2 style={{ color: '#ffffff', textAlign: 'center', paddingLeft: '1.2rem', paddingRight: '1.2rem' }}>
        ¿Qué es la computación en la nube?
      </h2>
      <div
        style={{
          marginTop: '1rem',
          maxWidth: '800px',
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingLeft: '1.2rem',
          paddingRight: '1.2rem',
        }}
      >
        <iframe
          width="100%"
          height="400"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="Computación en la nube"
          frameBorder="0"
          allowFullScreen
          style={{ borderRadius: '8px' }}
        ></iframe>
      </div>
    </div>
  );
}
